module.exports = __webpack_public_path__ + "static/media/portfolio-img.ad5b092f.jpg";